const calculateAge = (birthDate) => {
  const [year, month, day] = birthDate.split("-").map(Number)
  const birthDateObj = new Date(year, month - 1, day)

  const today = new Date()

  let age = today.getFullYear() - birthDateObj.getFullYear()

  const currentMonth = today.getMonth()
  const birthMonth = birthDateObj.getMonth()

  if (
    currentMonth < birthMonth ||
    (currentMonth === birthMonth && today.getDate() < birthDateObj.getDate())
  ) {
    age--
  }

  return parseInt(age)
}

const diagnosticToBoolean = (value) => value === "yes"
const diagnosticToString = (value) => {
  return value ? "yes" : "no"
}

const formatDate = (isoString) => {
  return isoString
  // const date = new Date(isoString)
  //
  // // Get day with ordinal suffix (like '1st', '2nd', '10th')
  // const day = date.getDate()
  // let dayWithSuffix
  // if (day > 3 && day < 21) {
  //   dayWithSuffix = day + "th"
  // } else {
  //   switch (day % 10) {
  //     case 1:
  //       dayWithSuffix = day + "st"
  //       break
  //     case 2:
  //       dayWithSuffix = day + "nd"
  //       break
  //     case 3:
  //       dayWithSuffix = day + "rd"
  //       break
  //     default:
  //       dayWithSuffix = day + "th"
  //   }
  // }

  // Month names
  // const months = [
  //   "Jan",
  //   "Feb",
  //   "Mar",
  //   "Apr",
  //   "May",
  //   "Jun",
  //   "Jul",
  //   "Aug",
  //   "Sep",
  //   "Oct",
  //   "Nov",
  //   "Dec",
  // ]
  // const month = months[date.getMonth()]
  //
  // // Year
  // const year = date.getFullYear()
  //
  // // Time in 24-hour format
  // const hours = String(date.getHours()).padStart(2, "0")
  // const minutes = String(date.getMinutes()).padStart(2, "0")
  //
  // return `${dayWithSuffix} of ${month} ${year} ${hours}:${minutes}`
}

export { calculateAge, diagnosticToBoolean, diagnosticToString, formatDate }
